import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/decisions')({
  component: DecisionsLayout
});

function DecisionsLayout() {
  return <Outlet />;
}
